module.exports = __webpack_public_path__ + "media/images/eyecatch-shortcut-endroll-25a07e0a8b2ab875c185510421e4612e.jpg";